<script>
import Form from './Form.vue';

export default {
  name: 'Login',
  extends: Form,

  data() {
    return {
      fields: [
        {
          name: 'email',
          type: 'email',
          label: 'Email address'
        },
        {
          name: 'password',
          type: 'password',
          label: 'Password',
          pattern: '',
          title: '',
        }
      ]
    };
  }
};
</script>